import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const LicensePlateInput = lazy(() => import(/* webpackChunkName: "LicensePlateInput" */ './components/LicensePlateInput'));

const wrapInput = (input) => {
    const wrapper = document.createElement('div');
    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(input);

    return wrapper;
};

const licensePlateInputs = document.querySelectorAll('.license-plate-input');
licensePlateInputs.forEach((element, index) => {
    const props = parseDatasetToProps(element.dataset);

    render(
        <Suspense fallback={<></>}>
            <LicensePlateInput
                className={element.className}
                id={element.id}
                name={element.name}
                value={element.value}
                required={element.required}
                {...props}
            />
        </Suspense>,
        wrapInput(element)
    );
});
